// extracted by mini-css-extract-plugin
export default {"identifiersOverview":"IdentifiersOverview_identifiersOverview__8pV+t","searchIdentifiers":"IdentifiersOverview_searchIdentifiers__NGfdT"};